import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import { SettingsProvider } from './contexts/SettingsProvider';
import { TranslationProvider } from './translations';
import ScrollToTop from './components/ScrollToTop';
import Navbar from './components/Navbar';
import LandingPage from './pages/LandingPage';
import About from './pages/About';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import RiskDisclaimer from './pages/RiskDisclaimer';
import CookiesPolicy from './pages/CookiesPolicy';
import DefensivePublication from './pages/DefensivePublication';
import DefensivePublicationJournal from './pages/DefensivePublicationJournal';
import DefensivePublicationTDI from './pages/DefensivePublicationTDI';
import DefensivePublications from './pages/DefensivePublications';
import Partnership from './pages/Partnership';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <TranslationProvider>
      <AuthProvider>
        <SubscriptionProvider>
          <SettingsProvider>
            <Router>
              <ScrollToTop />
              <div className="flex flex-col min-h-screen bg-gray-900">
                <Navbar />
                <div className="flex-grow">
                  <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/privacy" element={<PrivacyPolicy />} />
                    <Route path="/terms" element={<TermsOfService />} />
                    <Route path="/risk-disclaimer" element={<RiskDisclaimer />} />
                    <Route path="/cookies" element={<CookiesPolicy />} />
                    <Route path="/legal/defensive-publications" element={<DefensivePublications />} />
                    <Route path="/legal/defensive-publication-plutus" element={<DefensivePublication />} />
                    <Route path="/legal/defensive-publication-journal" element={<DefensivePublicationJournal />} />
                    <Route path="/legal/defensive-publication-tdi" element={<DefensivePublicationTDI />} />
                    <Route path="/partnership" element={<Partnership />} />
                  </Routes>
                </div>
                <Footer />
              </div>
            </Router>
          </SettingsProvider>
        </SubscriptionProvider>
      </AuthProvider>
    </TranslationProvider>
  );
}

export default App;
